<script>
    /* If a component for some reason should not be rendered, but still not trigger the NullComponent showing of a missing background component */
    export default {
        render: () => null
    };
</script>